// Em.js
import React from 'react'
import './Em.css';
import YunHeader from '../Common/YunHeader/YunHeader';
import YunSection from '../Common/YunSection/YunSection';
import YunIcon from '../Common/YunIcon/YunIcon';

import Slider from '@material-ui/core/Slider';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Switch from '@material-ui/core/Switch';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import {
    setWindowTitle,
    cppSetWindowIcon,
    cppCloseWindow,
    cppBroadcastWndMsg,
    cppEnableAudioFFT,
} from '../../api/cpp'

import getProductInfo from '../../static/getProductInfo';
import { getUiExtConf } from '../../api/em';

/** 把后端 /v3/em/uiextconf 的返回转成 uiExtConf 形状（getXXXPre 认的就是这个形状） */
function buildUiExtConf(d) {
    const conf = { version: '3.9.7', isSetShortcutByEmModel: false };
    const keys = ['rate', 'humanize', 'flex', 'vibrato', 'tracking'];
    const params = d.params || {};
    keys.forEach((k) => {
        const p = params[k] || {};
        const presets = p.presets || [];
        const out = { name: p.name || k, isInit: true, value: Number(p.value) || 0 };
        for (let i = 0; i < 4; i++) {
            const item = presets[i] || {};
            out['pre' + (i + 1)] = { name: item.name || '', value: Number(item.value) || 0 };
        }
        conf[k] = out;
    });
    const s = d.shortcuts || {};
    conf.shortcut = { pre1: s.pre1 || {}, pre2: s.pre2 || {}, pre3: s.pre3 || {} };
    conf.shortcutLink = s.link || {};
    const lg = d.linkage || {};
    conf.emLinkage = lg.items || {};
    const sliderLink = lg.sliderLink || {};
    conf.linkage = {
        value: Number(lg.slider) || 0,
        isLinkRate: !!sliderLink.rate,
        isLinkFlex: !!sliderLink.flex,
        isLinkHumanize: !!sliderLink.humanize,
    };
    // 底栏勾选框：转成客户端认的 { name, show } 结构
    if (d.pageset) {
        conf.pageset = {};
        Object.keys(d.pageset).forEach((k) => {
            conf.pageset[k] = { name: k, show: !!d.pageset[k] };
        });
    }
    return conf;
}

import {
    getEmValueModel,
    setEmValueModel,
    getEmModelNames,
    getEmShortcut,
    setEmShortcut,
    getEmModelShortcut,
    setEmModelShortcut,
    getIsSetShortcutByEmModel,
    setIsSetShortcutByEmModel,
    getShortcutLink,
    setShortcutLink,
    getIsSetEnableAudioFFT,
    setIsSetEnableAudioFFT,
    getComponentNotFree,
    setComponentNotFree,
    getRatePre,
    setRatePre,
    getHumanizePre,
    setHumanizePre,
    getVibratoPre,
    setVibratoPre,
    getFlexPre,
    setFlexPre,
    getTrackingPre,
    setTrackingPre,
    getEmLinkage,
    setEmLinkage,
} from '../App/local';

import {
    DefautlShortcut,
    DefaultShortcutLink,
    DefaultEmModelShortcut,
    EmValueRange,
    EmValueSelect,
    UiExtConf,
    Rate,
    Humanize,
    Vibrato,
    Flex,
    Tracking,
    EmLinkage,
} from '../App/data';
import { getPluginShowName, formatEmValByRange, getEmValueByLinkage } from '../App/tools';

const range = new EmValueRange();

class Em extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            productInfo: {},
            emPluginState: [],
            dia: false,
            curEmValue: EmValueSelect[0],
            emModel: {
                name: '男/女高音',
                value: 'soprano',
            },
            emModelNames: {
                soprano: '男/女高音',
                alto: '男/女中音',
                lowMale: '男/女低音',
            },
            emValueModel: getEmValueModel(),
            editEmShortcut: new DefautlShortcut(),
            shortcut: new DefautlShortcut(),
            shortcutLink: new DefaultShortcutLink(),
            isSetShortcutByEmModel: false,
            emModelShortcut: new DefaultEmModelShortcut(),
            // 是否有频谱功能和插件组件释放设置
            isExtraSection: !!window.cppEnableAudioFFT,
            // 是否启动播放器频谱
            enanleAudioFFT: getIsSetEnableAudioFFT(),
            // 是否释放插件组件
            componentNotFree: getComponentNotFree(),
            // 释放组件弹框
            componentDia: false,
            // 电音插件tab标签切换
            tabIndex: 1,
            // 速率预配置
            ratePre: new Rate(),
            // 拟人预配置
            humanizePre: new Humanize(),
            // 颤音预配置
            vibratoPre: new Vibrato(),
            // 弹性预配置
            flexPre: new Flex(),
            // 跟踪预配置
            trackingPre: new Tracking(),
            // 当前编辑的预配置
            editEmPre: new Rate(),
            // 联动调节
            emLinkage: new EmLinkage(),
            // 联动推杆
            emLinkageSlider: 50,
            // 联动电音参数
            emLinkageValue: {
                rate: 0,
                humanize: 0,
                vibrato: 0,
                flex: 0,
                tracking: 0
            },
        };
        this.clickSetEmValueModel = this.clickSetEmValueModel.bind(this);
        this.changeIsSetShortcutByEmModel = this.changeIsSetShortcutByEmModel.bind(this);
        this.changeShortcutLink = this.changeShortcutLink.bind(this);
        this.changePluginModel = this.changePluginModel.bind(this);
        this.changeEmShortcut = this.changeEmShortcut.bind(this);
        this.blurEmShortcut = this.blurEmShortcut.bind(this);
        this.blurEmShortcutName = this.blurEmShortcutName.bind(this);
        this.clickSaveEmShortcut = this.clickSaveEmShortcut.bind(this);
        this.handleCloseDia = this.handleCloseDia.bind(this);
        this.changeEnanleAudioFFT = this.changeEnanleAudioFFT.bind(this);
        this.changeComponentNotFree = this.changeComponentNotFree.bind(this);
        this.handleTabIndex = this.handleTabIndex.bind(this);
        this.changeEmValueSelect = this.changeEmValueSelect.bind(this);
        this.changeEmPre = this.changeEmPre.bind(this);
        this.blurEmPreName = this.blurEmPreName.bind(this);
        this.blurEmPreValue = this.blurEmPreValue.bind(this);
        this.clickSaveEmPre = this.clickSaveEmPre.bind(this);
        this.changeEmLinkageSlider = this.changeEmLinkageSlider.bind(this);
        this.changeEmLinkageIsLink = this.changeEmLinkageIsLink.bind(this);
        this.changeEmLinkage = this.changeEmLinkage.bind(this);
        this.blurEmLinkage = this.blurEmLinkage.bind(this);
        this.clickSaveEmLinkage = this.clickSaveEmLinkage.bind(this);
    }
    // 切换电音插件调节的tab
    handleTabIndex(index) {
        this.setState({
            tabIndex: index,
        })
    }
    // 改变独立设置预配置选项
    changeEmValueSelect(e, value) {
        if (value.props && value.props.value) {
            const curEmValue = value.props.value
            const emPreMap = {
                rate: this.state.ratePre,
                humanize: this.state.humanizePre,
                vibrato: this.state.vibratoPre,
                flex: this.state.flexPre,
                tracking: this.state.trackingPre,
            }
            this.setState({
                curEmValue: curEmValue,
                editEmPre: emPreMap[curEmValue.value]
            })
        }
    }
    // 修改预配置参数
    changeEmPre(e) {
        const { name, value } = e.target;
        const [topLevelKey, secondLevelKey] = name.split('.');
        const newEdit = JSON.parse(JSON.stringify(this.state.editEmPre))
        newEdit[topLevelKey][secondLevelKey] = value;
        this.setState({
            editEmPre: newEdit
        })
    }
    // 失焦格式化预配置name
    blurEmPreName(e) {
        const { name, value } = e.target;
        const [topLevelKey, secondLevelKey] = name.split('.');
        const newEdit = JSON.parse(JSON.stringify(this.state.editEmPre))
        const newValue = value.slice(0, 3);
        newEdit[topLevelKey][secondLevelKey] = newValue;
        this.setState({
            editEmPre: newEdit
        })
    }
    // 失焦格式化预配置value
    blurEmPreValue(e) {
        const { name, value } = e.target;
        const rangeKey = this.state.curEmValue.value;        
        const [topLevelKey, secondLevelKey] = name.split('.');
        const newEdit = JSON.parse(JSON.stringify(this.state.editEmPre))
        const newValue = formatEmValByRange(value, range[rangeKey])
        newEdit[topLevelKey][secondLevelKey] = newValue;
        this.setState({
            editEmPre: newEdit
        })
    }
    // 点击保存电音预配置
    clickSaveEmPre() {
        const newEdit = JSON.parse(JSON.stringify(this.state.editEmPre))
        const curEmValue = this.state.curEmValue
        const newState = {
            dia: true,
        }
        if (curEmValue.value === "rate") {
            setRatePre(newEdit)
            newState.ratePre = newEdit;
        } else if (curEmValue.value === "humanize") {
            setHumanizePre(newEdit)
            newState.humanizePre = newEdit;
        } else if (curEmValue.value === "vibrato") {
            setVibratoPre(newEdit)
            newState.vibratoPre = newEdit;
        } else if (curEmValue.value === "flex") {
            setFlexPre(newEdit)
            newState.flexPre = newEdit;
        } else if (curEmValue.value === "tracking") {
            setTrackingPre(newEdit)
            newState.trackingPre = newEdit;
        }
        setTimeout(() => {
            cppBroadcastWndMsg('UpdateEmPre');
        }, 500)
        this.setState(newState)
    }

    
    // 修改电音模式
    changePluginModel(e, value) {
        if (value.props && value.props.value) {
            this.setState({
                emModel: {
                    name: value.props.children,
                    value: value.props.value,
                }
            })
            if (this.state.isSetShortcutByEmModel) {
                this.setState({
                    editEmShortcut: this.state.emModelShortcut[value.props.value]
                })
            }
        }
    }
    // 改变是否关联配置
    changeIsSetShortcutByEmModel(e, value) {                
        this.setState({
            isSetShortcutByEmModel: value,
        })
        setIsSetShortcutByEmModel(value);
        if (value) {
            this.setState({
                editEmShortcut: this.state.emModelShortcut[this.state.emModel.value]
            })
        } else {
            this.setState({
                editEmShortcut: this.state.shortcut
            })
        }
    }
    // 修改快捷键关联
    changeShortcutLink(key, value) {
        const target = {};
        target[key] = value;
        const newShortcutLink = Object.assign(this.state.shortcutLink, target);
        this.setState({
            shortcutLink: newShortcutLink
        })
    }
    // 修改快捷配置
    changeEmShortcut(e) {
        const { name, value } = e.target;
        const [topLevelKey, secondLevelKey] = name.split('.');
        const newEdit = JSON.parse(JSON.stringify(this.state.editEmShortcut))
        newEdit[topLevelKey][secondLevelKey] = value;
        this.setState({
            editEmShortcut: newEdit
        })
    }
    blurEmShortcutName(e) {
        const { name, value } = e.target;
        const [topLevelKey, secondLevelKey] = name.split('.');
        const newEdit = JSON.parse(JSON.stringify(this.state.editEmShortcut))
        const newValue = value.slice(0, 3);
        newEdit[topLevelKey][secondLevelKey] = newValue;
        this.setState({
            editEmShortcut: newEdit
        })
    }
    // 对修改过后的快捷配置进行格式化
    blurEmShortcut(e, rangeKey) {
        const { name, value } = e.target;
        const [topLevelKey, secondLevelKey] = name.split('.');
        const newEdit = JSON.parse(JSON.stringify(this.state.editEmShortcut))
        const newValue = formatEmValByRange(value, range[rangeKey])
        newEdit[topLevelKey][secondLevelKey] = newValue;
        this.setState({
            editEmShortcut: newEdit
        })
    }
    // 保存快捷配置
    clickSaveEmShortcut() {
        // 保存到本地
        const newEdit = JSON.parse(JSON.stringify(this.state.editEmShortcut))
        if (this.state.isSetShortcutByEmModel) {
            const newEmModelShortcut = JSON.parse(JSON.stringify(this.state.emModelShortcut))
            newEmModelShortcut[this.state.emModel.value] = newEdit;
            this.setState({
                emModelShortcut: newEmModelShortcut
            })
            setEmModelShortcut(newEmModelShortcut)
        } else {
            this.setState({
                shortcut: newEdit
            })
            setEmShortcut(newEdit)
        }
        // setEmShortcut(this.state.editEmShortcut)
        setShortcutLink(this.state.shortcutLink)
        setTimeout(() => {
            cppBroadcastWndMsg('UpdateEmShortcut');
        }, 500)
        this.setState({
            dia: true
        })
    }

    // 联动调节推杆
    changeEmLinkageSlider(val) {
        const emLinkageValue = getEmValueByLinkage(val, this.state.emLinkage, range)
        this.setState({
            emLinkageSlider: val,
            emLinkageValue: emLinkageValue,
        })
    }
    // 联动调节是否关联
    changeEmLinkageIsLink(key, isLink) {
        const newEdit = JSON.parse(JSON.stringify(this.state.emLinkage))
        newEdit[key].isLink = isLink;
        const emLinkageValue = getEmValueByLinkage(this.state.emLinkageSlider, newEdit, range);
        this.setState({
            emLinkage: newEdit,
            emLinkageValue: emLinkageValue,
        })
    }
    // 修改联动调节起始值
    changeEmLinkage(e) {
        const { name, value } = e.target;
        const [topLevelKey, secondLevelKey] = name.split('.');
        const newEdit = JSON.parse(JSON.stringify(this.state.emLinkage))
        newEdit[topLevelKey][secondLevelKey] = value;
        this.setState({
            emLinkage: newEdit
        })
    }
    // 联动调节起始值失焦
    blurEmLinkage(e, rangeKey) {
        const { name, value } = e.target;
        const [topLevelKey, secondLevelKey] = name.split('.');
        const newEdit = JSON.parse(JSON.stringify(this.state.emLinkage))
        const newValue = formatEmValByRange(value, range[rangeKey])
        newEdit[topLevelKey][secondLevelKey] = newValue;
        this.setState({
            emLinkage: newEdit
        })
    }
    // 保存联动调节
    clickSaveEmLinkage() {
        setEmLinkage(this.state.emLinkage)
        cppBroadcastWndMsg('UpdateEmLinkage');
        this.setState({
            dia: true
        })
    }

    handleCloseDia() {
        this.setState({
            dia: false,
            componentDia: false,
        })
    }
    
    // 点击设置精调参数模式
    clickSetEmValueModel(model) {
        if (model === this.state.emPluginState) {
            return false
        }
        if (!['reset', 'renew', 'lock'].includes(model)) {
            model = 'lock'
        }
        this.setState({
            emValueModel: model,
        })
        setEmValueModel(model);
        // 将当前状态通知到主页面
        cppBroadcastWndMsg('EmValueModel' + model);
    }
    // 启用禁用播放器频谱
    changeEnanleAudioFFT(e, enable) {
        this.setState({
            enanleAudioFFT: enable
        })
        cppEnableAudioFFT(enable)
        setIsSetEnableAudioFFT(enable)
    }
    // 插件组件释放
    changeComponentNotFree(e, enable) {
        this.setState({
            componentNotFree: enable,
            componentDia: true
        })
        setComponentNotFree(enable)
    }
    // 读取电音精调配置
    //
    // 这个窗口是独立开的，拿不到 appId，getProductInfo() 会直接返回出厂默认对象；
    // 而且客户端这台机器上 localStorage 写不进（实测 sy_* 键一个都没落盘）。
    // 所以这里优先直接问后端 /v3/em/uiextconf，拿不到再退回 getProductInfo()。
    // componentDidMount 调一次；主界面点「恢复默认」会广播 Reload_State，也调它
    loadEmConf() {
        const fallback = () => {
            getProductInfo().then(productInfo => {
                this.seedEmConf(productInfo.uiExtConf, productInfo);
            }).catch(() => {
                this.seedEmConf(new UiExtConf(), null);
            });
        };
        getUiExtConf().then((res) => {
            const d = res && res.uiext;
            if (res && res.err === 'ERR_OK' && d && Number(d.enabled) === 1) {
                this.seedEmConf(buildUiExtConf(d), null);
                return;
            }
            fallback();
        }).catch(fallback);
    }
    // 用 uiExtConf 形状的数据铺满面板状态
    seedEmConf(uiExtConf, productInfo) {
        {
            console.log('[电音设置] 生效配置 =', uiExtConf);
            // 速率预配置
            const ratePre = getRatePre(new Rate(), uiExtConf);
            // 拟人预配置
            const humanizePre = getHumanizePre(new Humanize(), uiExtConf);
            // 颤音预配置
            const vibratoPre = getVibratoPre(new Vibrato(), uiExtConf);
            // 弹性预配置
            const flexPre = getFlexPre(new Flex(), uiExtConf);
            // 跟踪预配置
            const trackingPre = getTrackingPre(new Tracking(), uiExtConf);
            // 当前编辑的预配置
            const editEmPre = ratePre;
            // 快捷选项
            const shortcut = getEmShortcut(new DefautlShortcut(), uiExtConf);
            // 快捷选项关联
            const shortcutLink = getShortcutLink(new DefaultShortcutLink(), uiExtConf);
            // 是否启动按模式区分
            const isSetShortcutByEmModel = getIsSetShortcutByEmModel(uiExtConf);
            // 各个模式下的快捷选项
            const emModelShortcut = getEmModelShortcut(new DefaultEmModelShortcut(), uiExtConf);
            // 当前正在编辑的快捷选项
            const editEmShortcut = isSetShortcutByEmModel ? emModelShortcut[this.state.emModel.value] : shortcut;

            // 联动调节
            const emLinkage = getEmLinkage(new EmLinkage(), uiExtConf);
            const emLinkageValue = getEmValueByLinkage(this.state.emLinkageSlider, emLinkage, range);
            // 电音模式名称（后台可配）
            const emModelNames = getEmModelNames(uiExtConf);
            const curModelValue = this.state.emModel && this.state.emModel.value ? this.state.emModel.value : 'soprano';
            this.setState({
                productInfo: productInfo || this.state.productInfo,
                emModelNames: emModelNames,
                emModel: {
                    name: emModelNames[curModelValue] || this.state.emModel.name,
                    value: curModelValue,
                },
                shortcut: shortcut,
                shortcutLink: shortcutLink,
                isSetShortcutByEmModel: isSetShortcutByEmModel,
                emModelShortcut: emModelShortcut,
                editEmShortcut: editEmShortcut,
                ratePre: ratePre,
                humanizePre: humanizePre,
                vibratoPre: vibratoPre,
                flexPre: flexPre,
                trackingPre: trackingPre,
                editEmPre: editEmPre,
                emLinkage: emLinkage,
                emLinkageValue: emLinkageValue,
            })
            if (productInfo && productInfo.WindowIconFileName) {
                cppSetWindowIcon(productInfo.WindowIconFileName);
            }
        }
    }
    componentDidMount() {
        setWindowTitle('电音设置');
        this.loadEmConf();

        const localTabIndex = window.localStorage.getItem('sy_em_page_tab_index');
        if (localTabIndex === '2') {
            this.handleTabIndex(2)
        } else {
            this.handleTabIndex(1)
        }
        // 广播信息 同步插件状态
        setTimeout(() => {
            cppBroadcastWndMsg('Init_Plugin_State');
        }, 1000);

        // 监听别的页面的通知消息
        try {
            window.onRecvBroadcastWndMsg = (msg) => {
                if (msg === 'Login_In') {
                    // 回到登录页面时，关闭此页面
                    cppCloseWindow();
                }
                // 主界面点了「恢复默认」：重新读一遍本机/后台配置，否则这个窗口会一直显示旧值
                if (msg === 'Reload_State') {
                    this.loadEmConf();
                }
                // 收到插件同步消息 同步本地消息
                if (msg && /^EmpluginstateInfo/.test(msg)) {
                    const emPluginState = JSON.parse(msg.replace('EmpluginstateInfo', ''))
                    if (emPluginState && Array.isArray(emPluginState)) {
                        this.setState({
                            emPluginState: emPluginState
                        })
                    }
                }
            }
        } catch (error) {
        }
        // 监听插件状态
        try {
            window.onPluginStatChange = (name, online) => {
                if (typeof name === "string" && !name.includes("升降调") && !name.includes("消人声")) {
                    const pluginAry = JSON.parse(JSON.stringify(this.state.emPluginState));
                    if (online) {
                        pluginAry.push(name)
                    } else {
                        const index = pluginAry.indexOf(name);
                        if (index !== -1) {
                            pluginAry.splice(index, 1);
                        }
                    }
                    this.setState({
                        emPluginState: pluginAry
                    })
                }
            }
        } catch (error) {
        }
    }

    render() {
        const { emValueModel, emPluginState, editEmShortcut, isExtraSection, enanleAudioFFT,  componentNotFree, productInfo, emModel, emModelNames, isSetShortcutByEmModel, shortcutLink, dia, componentDia, tabIndex, curEmValue, editEmPre, emLinkage, emLinkageSlider, emLinkageValue, } = this.state;
        let diaClassName = "EmDia";
        let extraSetcionEle = null;
        let emModelSelectEle = null;
        if (isSetShortcutByEmModel) {
            emModelSelectEle = (
                <Select value="" onChange={this.changePluginModel}>
                    <MenuItem className="SelectItem" value="soprano">{emModelNames.soprano}</MenuItem>
                    <MenuItem className="SelectItem" value="alto">{emModelNames.alto}</MenuItem>
                    <MenuItem className="SelectItem" value="lowMale">{emModelNames.lowMale}</MenuItem>
                </Select>
            );
        }
        if (isExtraSection) {
            diaClassName = "EmDia l"
            extraSetcionEle = (
                <YunSection className="SettingBox Between" width="200" height="70">
                    <div className="Flex">
                        <div className="Label">
                            音频频谱显示
                        </div>
                        <Switch onChange={this.changeEnanleAudioFFT} checked={enanleAudioFFT} className="Normal"  color="primary" />
                    </div>
                    <div className="Flex">
                        <div className="Label">
                            AutoKey兼容
                        </div>
                        <Switch onChange={this.changeComponentNotFree} checked={componentNotFree} className="Normal"  color="primary" />
                    </div>
                </YunSection>
            )
        }
        return (
            <div className="Em AppContainer">
                <YunHeader hideOnTop hideMin productInfo={productInfo} title="电音设置"></YunHeader>
                {/* 电音插件状态 */}
                <YunSection className="SettingBox" width="200" height="60">
                    <div className="Flex">
                        <p className="Label">电音插件状态</p>
                        <p className="HoverColor MainColor">{emPluginState.length ? '已连接' : '未连接'}</p>
                    </div>
                    <div>
                        <p className="Text">{getPluginShowName(emPluginState[emPluginState.length - 1])}</p>
                    </div>
                </YunSection>
                {/* 电音设置 */}
                <YunSection className="EmSettingBox" width="200" height="261">
                    <div className="EmSettingBoxHeader Flex">
                        {
                            ["独立设置", "快捷配置", "联动调节"].map((item, index) => {
                                return (
                                    <div key={index} onClick={() => this.handleTabIndex(index)} className={`EmSettingBoxTab MainColor7 ${tabIndex === index ? 'Active' : ''}`}>{item}</div>
                                )
                            })
                        }
                    </div>
                    <div className="EmSettingBoxView">
                        <div className="EmSettingBoxWrapper" style={{ transform: `translateX(-${tabIndex * 200}px)` }}>
                            {/* 独立设置 */}
                            <div className="EmSettingBoxContent">
                                <div className="EmSettingBoxItem Flex Start">
                                    <div className="Label">调节项 ：</div>
                                    <div className="Content YunSelect YunBtn MainColor2">
                                        <div className="SelectLabel">
                                            {curEmValue.name}
                                        </div>
                                        <YunIcon icon="expand"></YunIcon>
                                        <Select value="" onChange={this.changeEmValueSelect}>
                                            {EmValueSelect.map((item, index) => {
                                                return (
                                                    <MenuItem className="SelectItem" key={index} value={item}>{item.name}</MenuItem>
                                                )
                                            })}
                                        </Select>
                                    </div>
                                </div>
                                <div className="EmSettingBoxItem Flex Start">
                                    <div className="Label">插件名 ：</div>
                                    <div className="Content TextCenter MainColor6">{curEmValue.plugName}</div>
                                </div>
                                <div className="EmSettingBoxItem Flex Start">
                                    <div className="Label">参数范围：</div>
                                    <div className="Content TextCenter">{curEmValue.range}</div>
                                </div>
                                <div className="EmSettingBoxItem Flex Start FlexStart">
                                    <div className="Label">
                                        <div>预存选择：</div>
                                        <div className="MainColor">下拉菜单</div>
                                    </div>
                                    <div className="Content">
                                        <div className="Flex">
                                            <div className="EmValueSet EmValueName"><input onBlur={this.blurEmPreName} onChange={this.changeEmPre} value={editEmPre.pre1.name} name="pre1.name" type="text" /></div>
                                            <div className="EmValueSet"><input onBlur={this.blurEmPreValue} onChange={this.changeEmPre} value={editEmPre.pre1.value} name="pre1.value" type="text" /></div>
                                        </div>
                                        <div className="Flex TopGap">
                                            <div className="EmValueSet EmValueName"><input onBlur={this.blurEmPreName} onChange={this.changeEmPre} value={editEmPre.pre2.name} name="pre2.name" type="text" /></div>
                                            <div className="EmValueSet"><input onBlur={this.blurEmPreValue} onChange={this.changeEmPre} value={editEmPre.pre2.value} name="pre2.value" type="text" /></div>
                                        </div>
                                        <div className="Flex TopGap">
                                            <div className="EmValueSet EmValueName"><input onBlur={this.blurEmPreName} onChange={this.changeEmPre} value={editEmPre.pre3.name} name="pre3.name" type="text" /></div>
                                            <div className="EmValueSet"><input onBlur={this.blurEmPreValue} onChange={this.changeEmPre} value={editEmPre.pre3.value} name="pre3.value" type="text" /></div>
                                        </div>
                                        <div className="Flex TopGap">
                                            <div className="EmValueSet EmValueName"><input onBlur={this.blurEmPreName} onChange={this.changeEmPre} value={editEmPre.pre4.name} name="pre4.name" type="text" /></div>
                                            <div className="EmValueSet"><input onBlur={this.blurEmPreValue} onChange={this.changeEmPre} value={editEmPre.pre4.value} name="pre4.value" type="text" /></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="EmSettingBoxFooter Flex Center">
                                    <div onClick={this.clickSaveEmPre} className="YunBtn">应用</div>
                                </div>
                            </div>
                            {/* 快捷配置 */}
                            <div className="EmSettingBoxContent">
                                <div className="Flex TopGap">
                                    <div className="Flex">
                                        <div>模式：</div>
                                        <div className="YunSelect YunBtn MainColor2">
                                            <div className="SelectLabel">
                                                {isSetShortcutByEmModel ? emModel.name : "默认"}
                                            </div>
                                            <YunIcon icon="expand"></YunIcon>
                                            {emModelSelectEle}
                                        </div>
                                    </div>
                                    <div>
                                        <div className="LineHeight">按模式区分</div>
                                        <div className="Flex Center">
                                            <Switch
                                                checked={isSetShortcutByEmModel}
                                                onChange={this.changeIsSetShortcutByEmModel}
                                                color="primary"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="Flex TopGap EmValueSetTitle">
                                    <div className="EmValueSetHeader">
                                        <div className="MainColor HoverColor">关联</div>
                                    </div>
                                    <div className="EmValueSet"><input onBlur={this.blurEmShortcutName} onChange={this.changeEmShortcut} name="pre1.name" value={editEmShortcut.pre1.name} type="text" /></div>
                                    <div className="EmValueSet"><input onBlur={this.blurEmShortcutName} onChange={this.changeEmShortcut} name="pre2.name" value={editEmShortcut.pre2.name} type="text" /></div>
                                    <div className="EmValueSet"><input onBlur={this.blurEmShortcutName} onChange={this.changeEmShortcut} name="pre3.name" value={editEmShortcut.pre3.name} type="text" /></div>
                                </div>
                                <div className="Flex TopGap">
                                    <div className="EmValueSetHeader">
                                        <div>强度：</div>
                                        <Switch onChange={(e, value) => this.changeShortcutLink('rate', value)} checked={shortcutLink.rate} color="primary" />
                                    </div>
                                    <div className="EmValueSet Num"><input onBlur={(e) => this.blurEmShortcut(e, 'rate')} onChange={this.changeEmShortcut} name="pre1.rate" value={editEmShortcut.pre1.rate} type="text" /></div>
                                    <div className="EmValueSet Num"><input onBlur={(e) => this.blurEmShortcut(e, 'rate')} onChange={this.changeEmShortcut} name="pre2.rate" value={editEmShortcut.pre2.rate} type="text" /></div>
                                    <div className="EmValueSet Num"><input onBlur={(e) => this.blurEmShortcut(e, 'rate')} onChange={this.changeEmShortcut} name="pre3.rate" value={editEmShortcut.pre3.rate} type="text" /></div>
                                </div>
                                <div className="Flex TopGap">
                                    <div className="EmValueSetHeader">
                                        <div>拟人：</div>
                                        <Switch onChange={(e, value) => this.changeShortcutLink('humanize', value)} checked={shortcutLink.humanize} color="primary" />
                                    </div>
                                    <div className="EmValueSet Num"><input onBlur={(e) => this.blurEmShortcut(e, 'humanize')} onChange={this.changeEmShortcut} name="pre1.humanize" value={editEmShortcut.pre1.humanize} type="text" /></div>
                                    <div className="EmValueSet Num"><input onBlur={(e) => this.blurEmShortcut(e, 'humanize')} onChange={this.changeEmShortcut} name="pre2.humanize" value={editEmShortcut.pre2.humanize} type="text" /></div>
                                    <div className="EmValueSet Num"><input onBlur={(e) => this.blurEmShortcut(e, 'humanize')} onChange={this.changeEmShortcut} name="pre3.humanize" value={editEmShortcut.pre3.humanize} type="text" /></div>
                                </div>
                                <div className="Flex TopGap">
                                    <div className="EmValueSetHeader">
                                        <div>颤音：</div>
                                        <Switch onChange={(e, value) => this.changeShortcutLink('vibrato', value)} checked={shortcutLink.vibrato} color="primary" />
                                    </div>
                                    <div className="EmValueSet Num"><input onBlur={(e) => this.blurEmShortcut(e, 'vibrato')} onChange={this.changeEmShortcut} name="pre1.vibrato" value={editEmShortcut.pre1.vibrato} type="text" /></div>
                                    <div className="EmValueSet Num"><input onBlur={(e) => this.blurEmShortcut(e, 'vibrato')} onChange={this.changeEmShortcut} name="pre2.vibrato" value={editEmShortcut.pre2.vibrato} type="text" /></div>
                                    <div className="EmValueSet Num"><input onBlur={(e) => this.blurEmShortcut(e, 'vibrato')} onChange={this.changeEmShortcut} name="pre3.vibrato" value={editEmShortcut.pre3.vibrato} type="text" /></div>
                                </div>
                                <div className="Flex TopGap">
                                    <div className="EmValueSetHeader">
                                        <div>弹性：</div>
                                        <Switch onChange={(e, value) => this.changeShortcutLink('flex', value)} checked={shortcutLink.flex} color="primary" />
                                    </div>
                                    <div className="EmValueSet Num"><input onBlur={(e) => this.blurEmShortcut(e, 'flex')} onChange={this.changeEmShortcut} name="pre1.flex" value={editEmShortcut.pre1.flex} type="text" /></div>
                                    <div className="EmValueSet Num"><input onBlur={(e) => this.blurEmShortcut(e, 'flex')} onChange={this.changeEmShortcut} name="pre2.flex" value={editEmShortcut.pre2.flex} type="text" /></div>
                                    <div className="EmValueSet Num"><input onBlur={(e) => this.blurEmShortcut(e, 'flex')} onChange={this.changeEmShortcut} name="pre3.flex" value={editEmShortcut.pre3.flex} type="text" /></div>
                                </div>
                                <div className="Flex TopGap">
                                    <div className="EmValueSetHeader">
                                        <div>跟踪：</div>
                                        <Switch onChange={(e, value) => this.changeShortcutLink('tracking', value)} checked={shortcutLink.tracking} color="primary" />
                                    </div>
                                    <div className="EmValueSet Num"><input onBlur={(e) => this.blurEmShortcut(e, 'tracking')} onChange={this.changeEmShortcut} name="pre1.tracking" value={editEmShortcut.pre1.tracking} type="text" /></div>
                                    <div className="EmValueSet Num"><input onBlur={(e) => this.blurEmShortcut(e, 'tracking')} onChange={this.changeEmShortcut} name="pre2.tracking" value={editEmShortcut.pre2.tracking} type="text" /></div>
                                    <div className="EmValueSet Num"><input onBlur={(e) => this.blurEmShortcut(e, 'tracking')} onChange={this.changeEmShortcut} name="pre3.tracking" value={editEmShortcut.pre3.tracking} type="text" /></div>
                                </div>
                                <div className="EmSettingBoxFooter Flex Center">
                                    <div onClick={this.clickSaveEmShortcut} className="YunBtn">应用</div>
                                </div>
                            </div>
                            {/* 联动调节 */}
                            <div className="EmSettingBoxContent">
                                <div className="EmSettingBoxItem Ld Flex">
                                    <div className="Label">联调：</div>
                                    <div className="Content Flex End">
                                        <Slider
                                            onChange={(e, val) => this.changeEmLinkageSlider(val)}
                                            value={emLinkageSlider}
                                            min={0}
                                            max={100} />
                                        <div className="ValueLabel MainColor">{emLinkageSlider}</div>
                                    </div>
                                </div>
                                <div className="EmSettingBoxItem Ld Flex">
                                    <div className="Label MainColor">关联：</div>
                                    <div className="Content Flex">
                                        <div className="LdW">MIN</div>
                                        <div>当前值</div>
                                        <div className="LdW">MAX</div>
                                    </div>
                                </div>
                                <div className="EmSettingBoxItem Ld Flex">
                                    <div className="Label">
                                        <div>强度：</div>
                                        <Switch onChange={(e, value) => this.changeEmLinkageIsLink('rate', value)} checked={emLinkage.rate.isLink} color="primary" />
                                    </div>
                                    <div className="Content Flex">
                                        <div className="EmValueSet"><input onChange={this.changeEmLinkage} onBlur={(e) => this.blurEmLinkage(e, "rate")} value={emLinkage.rate.start} name="rate.start" type="text" /></div>
                                        <div className="MainColor">{emLinkageValue.rate}</div>
                                        <div className="EmValueSet"><input onChange={this.changeEmLinkage} onBlur={(e) => this.blurEmLinkage(e, "rate")} value={emLinkage.rate.end} name="rate.end" type="text" /></div>
                                    </div>
                                </div>
                                <div className="EmSettingBoxItem Ld Flex">
                                    <div className="Label">
                                        <div>拟人：</div>
                                        <Switch onChange={(e, value) => this.changeEmLinkageIsLink('humanize', value)} checked={emLinkage.humanize.isLink} color="primary" />
                                    </div>
                                    <div className="Content Flex">
                                        <div className="EmValueSet"><input onChange={this.changeEmLinkage} onBlur={(e) => this.blurEmLinkage(e, "humanize")} value={emLinkage.humanize.start} name="humanize.start" type="text" /></div>
                                        <div className="MainColor">{emLinkageValue.humanize}</div>
                                        <div className="EmValueSet"><input onChange={this.changeEmLinkage} onBlur={(e) => this.blurEmLinkage(e, "humanize")} value={emLinkage.humanize.end} name="humanize.end" type="text" /></div>
                                    </div>
                                </div>
                                <div className="EmSettingBoxItem Ld Flex">
                                    <div className="Label">
                                        <div>颤音：</div>
                                        <Switch onChange={(e, value) => this.changeEmLinkageIsLink('vibrato', value)} checked={emLinkage.vibrato.isLink} color="primary" />
                                    </div>
                                    <div className="Content Flex">
                                        <div className="EmValueSet"><input onChange={this.changeEmLinkage} onBlur={(e) => this.blurEmLinkage(e, "vibrato")} value={emLinkage.vibrato.start} name="vibrato.start" type="text" /></div>
                                        <div className="MainColor">{emLinkageValue.vibrato}</div>
                                        <div className="EmValueSet"><input onChange={this.changeEmLinkage} onBlur={(e) => this.blurEmLinkage(e, "vibrato")} value={emLinkage.vibrato.end} name="vibrato.end" type="text" /></div>
                                    </div>
                                </div>
                                <div className="EmSettingBoxItem Ld Flex">
                                    <div className="Label">
                                        <div>弹性：</div>
                                        <Switch onChange={(e, value) => this.changeEmLinkageIsLink('flex', value)} checked={emLinkage.flex.isLink} color="primary" />
                                    </div>
                                    <div className="Content Flex">
                                        <div className="EmValueSet"><input onChange={this.changeEmLinkage} onBlur={(e) => this.blurEmLinkage(e, "flex")} value={emLinkage.flex.start} name="flex.start" type="text" /></div>
                                        <div className="MainColor">{emLinkageValue.flex}</div>
                                        <div className="EmValueSet"><input onChange={this.changeEmLinkage} onBlur={(e) => this.blurEmLinkage(e, "flex")} value={emLinkage.flex.end} name="flex.end" type="text" /></div>
                                    </div>
                                </div>
                                <div className="EmSettingBoxItem Ld Flex">
                                    <div className="Label">
                                        <div>跟踪：</div>
                                        <Switch onChange={(e, value) => this.changeEmLinkageIsLink('tracking', value)} checked={emLinkage.tracking.isLink} color="primary" />
                                    </div>
                                    <div className="Content Flex">
                                        <div className="EmValueSet"><input onChange={this.changeEmLinkage} onBlur={(e) => this.blurEmLinkage(e, "tracking")} value={emLinkage.tracking.start} name="tracking.start" type="text" /></div>
                                        <div className="MainColor">{emLinkageValue.tracking}</div>
                                        <div className="EmValueSet"><input onChange={this.changeEmLinkage} onBlur={(e) => this.blurEmLinkage(e, "tracking")} value={emLinkage.tracking.end} name="tracking.end" type="text" /></div>
                                    </div>
                                </div>
                                <div className="EmSettingBoxFooter Flex Center">
                                    <div onClick={this.clickSaveEmLinkage} className="YunBtn">应用</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </YunSection>
                <YunSection className="SettingBox Between" width="200" height="131">
                    <div className="Label">
                        电音精调参数
                    </div>
                    <div className={emValueModel === "reset" ? "ModelSelect Active" : "ModelSelect"}>
                        <div onClick={() => this.clickSetEmValueModel("reset")} className="YunBtn Large">自动重置</div>
                        <div className="CursorDefault">切歌恢复默认值</div>
                    </div>
                    <div className={emValueModel === "renew" ? "ModelSelect Active" : "ModelSelect"}>
                        <div onClick={() => this.clickSetEmValueModel("renew")} className="YunBtn Large">自动恢复</div>
                        <div className="CursorDefault">
                            <p className="">切歌恢复设置值</p>
                            <p className="MainColor">(之前您的设置值)</p>
                        </div>
                    </div>
                    <div className={emValueModel === "lock" ? "ModelSelect Active" : "ModelSelect"}>
                        <div onClick={() => this.clickSetEmValueModel("lock")} className="YunBtn Large">锁定状态</div>
                        <div className="CursorDefault">参数和切歌无关</div>
                    </div>
                </YunSection>
                {extraSetcionEle}
                <Dialog open={dia} className={diaClassName}>
                    <DialogTitle>
                        提示
                    </DialogTitle>
                    <DialogContent>
                        已将您的设置应用于首界面
                    </DialogContent>
                    <DialogActions>
                        <div className="YunBtn Small" onClick={this.handleCloseDia}>确认</div>
                    </DialogActions>
                </Dialog>
                <Dialog open={componentDia} className={diaClassName}>
                    <DialogTitle>
                        提示
                    </DialogTitle>
                    <DialogContent>
                        设置成功，重启软件后生效
                    </DialogContent>
                    <DialogActions>
                        <div className="YunBtn Small" onClick={this.handleCloseDia}>确认</div>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

export default Em;
